import { createEffect, onCleanup } from "solid-js";
import { useActiveBot } from "../state/activeBot";
import { subscribeBotEngineEvents } from "../services/botEngineEvents";
import { messageSoundEnabled, playMessageSound } from "../services/messageSound";

export default function MessageSoundListener() {
  const { bots } = useActiveBot();

  createEffect(() => {
    if (!messageSoundEnabled()) return;
    const unsubs = bots().map((b) =>
      subscribeBotEngineEvents(b.id, (evt) => {
        if (evt.type !== "msg_received") return;
        if (evt.payload?.isOutgoing) return;
        if (typeof document !== "undefined" && document.visibilityState !== "visible") return;
        playMessageSound();
      }),
    );
    onCleanup(() => unsubs.forEach((u) => u()));
  });

  return null;
}
